function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#939598;}.cls-2{fill:#184798;}.cls-3{fill:#87c540;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "COI - LogoTagline - Pos");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M17.17,116.64V133H14.61V121.52l-6,6-6-6V133H0V116.64H1.29l7.29,7.26,7.3-7.26Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M26.14,133h-2.8l7.07-16.34h1.4L38.87,133h-2.8l-1.53-3.52H27.67Zm5-11.5-2.34,5.42h4.68Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M50.93,124l6.78,9H54.52l-5.36-7.11-1.6,1.71V133H45V116.75h2.56v7.11l0,0v0l.09-.06,6.63-7.09h3.5Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M67,133H64.4V116.68H67Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M84.86,133l-8.38-10.54V133H73.92V116.64h1.25l8.92,11.26V116.64h2.56V133Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M106.75,131.25l-.56.4a7.74,7.74,0,0,1-2.16,1,8.18,8.18,0,0,1-2.37.34,7.84,7.84,0,0,1-3.17-.64,8.55,8.55,0,0,1-2.61-1.75,8.24,8.24,0,0,1-1.76-2.6,8.22,8.22,0,0,1,0-6.36,8.19,8.19,0,0,1,1.76-2.59,8.37,8.37,0,0,1,2.61-1.75,7.85,7.85,0,0,1,3.17-.65A8.18,8.18,0,0,1,104,117a8.06,8.06,0,0,1,2.16,1l-1.4,2.1a5.56,5.56,0,0,0-3.13-.94,5.42,5.42,0,0,0-2.21.45,5.59,5.59,0,0,0-1.8,1.21,5.83,5.83,0,0,0-1.21,1.79,5.6,5.6,0,0,0,0,4.4,5.71,5.71,0,0,0,1.21,1.79,5.79,5.79,0,0,0,1.8,1.22,5.42,5.42,0,0,0,2.21.45,5.58,5.58,0,0,0,2.58-.62v-4.5h-2.58v-2.52h5.09Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M123.86,116.64h12.71v2.56H131.5V133h-2.56V119.2h-5.08Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M153.39,116.68H156V133h-2.56V125.3H145.8V133h-2.56V116.68h2.56v6.06h7.59Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M173.54,133H163V116.7h10.59v2.52h-8.07v3.68h7v2.51h-7v5.08h8.07Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M197.63,133l-7-16.34h2.77l5,11.64,4-8.82,4,8.82,5-11.64h2.78l-7,16.34h-1.45l-3.3-7.31L199.07,133Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M226.15,116.64a7.84,7.84,0,0,1,3.17.64,8.26,8.26,0,0,1,2.61,1.77,8.35,8.35,0,0,1,1.76,2.6,8.22,8.22,0,0,1,0,6.36,8.24,8.24,0,0,1-1.76,2.6,8.55,8.55,0,0,1-2.61,1.75,8.22,8.22,0,0,1-6.36,0,8.34,8.34,0,0,1-2.59-1.75,8.21,8.21,0,0,1-1.75-2.6,8.1,8.1,0,0,1,0-6.36,8.33,8.33,0,0,1,1.75-2.6,8.06,8.06,0,0,1,2.59-1.77A7.91,7.91,0,0,1,226.15,116.64Zm0,14a5.59,5.59,0,0,0,2.23-.45,5.76,5.76,0,0,0,3.53-5.33,5.59,5.59,0,0,0-.45-2.23,5.8,5.8,0,0,0-1.24-1.84,5.66,5.66,0,0,0-1.84-1.23,5.59,5.59,0,0,0-2.23-.45,5.65,5.65,0,0,0-2.25.45,5.68,5.68,0,0,0-3.07,3.07,5.59,5.59,0,0,0-.45,2.23,5.79,5.79,0,0,0,1.68,4.09,5.8,5.8,0,0,0,1.84,1.24A5.65,5.65,0,0,0,226.15,130.6Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M249.83,133l-4.26-6.17h-2.68v6.24h-2.56V116.64l7.55,0a4.78,4.78,0,0,1,2,.41,5.08,5.08,0,0,1,3.09,4.71,4.88,4.88,0,0,1-.33,1.8,4.75,4.75,0,0,1-.92,1.51,5.06,5.06,0,0,1-3.08,1.68l4.31,6.21Zm-2-8.68a2.37,2.37,0,0,0,1-.2,2.4,2.4,0,0,0,.79-.55,2.72,2.72,0,0,0,.53-.8,2.4,2.4,0,0,0,.2-1,2.62,2.62,0,0,0-.2-1,2.66,2.66,0,0,0-.54-.82,2.93,2.93,0,0,0-.8-.55,2.25,2.25,0,0,0-1-.21h-5v5.07Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M270.56,130.44V133H259.29V116.68h2.56v13.76Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M277,133v-16.3h5.1a7.89,7.89,0,0,1,3.17.65,8.19,8.19,0,0,1,2.59,1.76,8.4,8.4,0,0,1,1.75,2.59,8,8,0,0,1,0,6.32,8.32,8.32,0,0,1-4.34,4.34,7.88,7.88,0,0,1-3.17.64Zm2.56-2.54,2.54,0a5.51,5.51,0,0,0,2.18-.43,5.79,5.79,0,0,0,1.78-1.21,5.63,5.63,0,0,0,1.2-1.79,5.44,5.44,0,0,0,.44-2.18,5.51,5.51,0,0,0-.44-2.18,5.68,5.68,0,0,0-3-3,5.51,5.51,0,0,0-2.18-.44h-2.54Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M324.51,116.64V133H322V121.52l-6,6-6-6V133h-2.56V116.64h1.29l7.29,7.26,7.31-7.26Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M339,116.64a7.88,7.88,0,0,1,3.17.64,8.21,8.21,0,0,1,2.6,1.77,8.35,8.35,0,0,1,1.76,2.6,8.1,8.1,0,0,1,0,6.36,8.24,8.24,0,0,1-1.76,2.6,8.5,8.5,0,0,1-2.6,1.75,8.25,8.25,0,0,1-6.37,0,8.45,8.45,0,0,1-2.59-1.75,8.21,8.21,0,0,1-1.75-2.6,8.1,8.1,0,0,1,0-6.36,8.33,8.33,0,0,1,1.75-2.6,8.17,8.17,0,0,1,2.59-1.77A8,8,0,0,1,339,116.64Zm0,14a5.69,5.69,0,0,0,4.06-1.69,5.74,5.74,0,0,0,1.69-4.09,5.59,5.59,0,0,0-.45-2.23,5.8,5.8,0,0,0-1.24-1.84,5.77,5.77,0,0,0-8.15,0,5.8,5.8,0,0,0-1.24,1.84,5.59,5.59,0,0,0-.45,2.23A5.75,5.75,0,0,0,339,130.6Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M362.64,133l-4.25-6.17H355.7v6.24h-2.56V116.64l7.55,0a4.86,4.86,0,0,1,2,.41,5.1,5.1,0,0,1,1.6,1.09,5,5,0,0,1,1.09,1.63,5.15,5.15,0,0,1,.39,2,4.88,4.88,0,0,1-.33,1.8,4.75,4.75,0,0,1-.92,1.51,5,5,0,0,1-3.08,1.68l4.31,6.21Zm-1.94-8.68a2.44,2.44,0,0,0,1-.2,2.36,2.36,0,0,0,.78-.55,2.75,2.75,0,0,0,.54-.8,2.4,2.4,0,0,0,.19-1,2.62,2.62,0,0,0-.19-1,2.88,2.88,0,0,0-.55-.82,2.78,2.78,0,0,0-.8-.55,2.22,2.22,0,0,0-1-.21h-5v5.07Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M383,133H372.37V116.7H383v2.52h-8.07v3.68h7v2.51h-7v5.08H383Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M411.22,133H400.63V116.7h10.59v2.52h-8.07v3.68h7v2.51h-7v5.08h8.07Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M429,133l-8.37-10.54V133h-2.56V116.64h1.24l8.93,11.26V116.64h2.56V133Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M448,133H437.41V116.7H448v2.52h-8.07v3.68h7v2.51h-7v5.08H448Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M464.06,133l-4.26-6.17h-2.68v6.24h-2.56V116.64l7.54,0a4.83,4.83,0,0,1,2,.41,5.15,5.15,0,0,1,1.61,1.09,5.18,5.18,0,0,1,1.48,3.62,4.88,4.88,0,0,1-.33,1.8,5.09,5.09,0,0,1-4,3.19l4.31,6.21Zm-1.95-8.68a2.43,2.43,0,0,0,1.76-.75,2.72,2.72,0,0,0,.53-.8,2.4,2.4,0,0,0,.2-1,2.62,2.62,0,0,0-.2-1,2.66,2.66,0,0,0-.54-.82,2.93,2.93,0,0,0-.8-.55,2.25,2.25,0,0,0-1-.21h-5v5.07Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M486.56,131.25l-.57.4a7.68,7.68,0,0,1-2.15,1,8.25,8.25,0,0,1-2.38.34,7.88,7.88,0,0,1-3.17-.64,8.5,8.5,0,0,1-2.6-1.75,8.08,8.08,0,0,1-1.76-2.6,8.1,8.1,0,0,1,0-6.36,8,8,0,0,1,1.76-2.59,8.33,8.33,0,0,1,2.6-1.75,7.89,7.89,0,0,1,3.17-.65,8.25,8.25,0,0,1,2.38.34,8,8,0,0,1,2.15,1l-1.4,2.1a5.67,5.67,0,0,0-5.34-.49,5.66,5.66,0,0,0-1.79,1.21,5.83,5.83,0,0,0-1.21,1.79,5.6,5.6,0,0,0,0,4.4,5.71,5.71,0,0,0,1.21,1.79,5.86,5.86,0,0,0,1.79,1.22,5.49,5.49,0,0,0,2.21.45,5.65,5.65,0,0,0,2.59-.62v-4.5h-2.59v-2.52h5.1Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M504.89,116.64l-5.16,8.53V133h-2.56v-7.81l-5.1-8.53h3l3.41,5.69,3.44-5.69Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M532.46,133H521.87V116.7h10.59v2.52h-8.08v3.68h7v2.51h-7v5.08h8.08Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M541.84,133.05h-2.56V116.68H550.2v2.56h-8.36v4h7.51v2.55h-7.51Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M558.64,133.05h-2.56V116.68H567v2.56h-8.36v4h7.51v2.55h-7.51Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M576.12,133h-2.56V116.68h2.56Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M590.6,133a7.88,7.88,0,0,1-3.17-.64,8.33,8.33,0,0,1-2.6-1.75,8.14,8.14,0,0,1-1.76-2.59,8.13,8.13,0,0,1,0-6.37,8.3,8.3,0,0,1,4.36-4.36,7.89,7.89,0,0,1,3.17-.65A8.26,8.26,0,0,1,593,117a8.37,8.37,0,0,1,2.15,1l-1.38,2.09a5.52,5.52,0,0,0-3.15-1,5.66,5.66,0,0,0-2.21.44,6,6,0,0,0-1.8,1.22,5.88,5.88,0,0,0-1.23,1.8,5.63,5.63,0,0,0,0,4.41,5.65,5.65,0,0,0,1.23,1.8,6,6,0,0,0,1.8,1.21,5.49,5.49,0,0,0,2.21.45,5.7,5.7,0,0,0,3.15-.94l1.38,2.09a8,8,0,0,1-2.15,1A8.25,8.25,0,0,1,590.6,133Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M604.76,133H602.2V116.68h2.56Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M622.3,133H611.71V116.7H622.3v2.52h-8.07v3.68h7v2.51h-7v5.08h8.07Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M640.06,133l-8.37-10.54V133h-2.56V116.64h1.24l8.93,11.26V116.64h2.56V133Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M648.4,116.64h12.71v2.56H656V133h-2.56V119.2H648.4Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M44.13,89.32A42.53,42.53,0,0,1,27,85.84,45.46,45.46,0,0,1,13,76.4a44.22,44.22,0,0,1-9.5-14A42.82,42.82,0,0,1,0,45.19,42.53,42.53,0,0,1,3.48,28.08,44.76,44.76,0,0,1,27,4.54,42.53,42.53,0,0,1,44.13,1.06a43.19,43.19,0,0,1,24.42,7.5L61.12,19.82a29.68,29.68,0,0,0-17-5.19A29.53,29.53,0,0,0,32.21,17,31.25,31.25,0,0,0,15.87,33.32a29.3,29.3,0,0,0-2.42,11.87,29.73,29.73,0,0,0,2.42,11.93,30.31,30.31,0,0,0,6.61,9.7,31.91,31.91,0,0,0,9.73,6.52,29.53,29.53,0,0,0,11.92,2.41,30.53,30.53,0,0,0,17-5.07l7.43,11.26a41.48,41.48,0,0,1-11.62,5.53A44.28,44.28,0,0,1,44.13,89.32Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M125.9,89.91a43.76,43.76,0,0,1-17.53-3.54,45.31,45.31,0,0,1-24-24.07,44.18,44.18,0,0,1-3.54-17.58,43.91,43.91,0,0,1,3-16.23A46.58,46.58,0,0,1,92,14.93,45.25,45.25,0,0,1,104.36,5a42.87,42.87,0,0,1,15.4-5V13.45a31.48,31.48,0,0,0-10.15,3.89,31.06,31.06,0,0,0-8.14,7A34.14,34.14,0,0,0,96,33.75a30.25,30.25,0,0,0-2,11,31,31,0,0,0,2.48,12.39,32.09,32.09,0,0,0,17,17,32.17,32.17,0,0,0,24.77,0,32.16,32.16,0,0,0,17-17,31.18,31.18,0,0,0,2.47-12.39,30.84,30.84,0,0,0-1.94-10.86,33,33,0,0,0-5.31-9.32,31.83,31.83,0,0,0-18-11V.12a43.6,43.6,0,0,1,15.22,5.13A44.71,44.71,0,0,1,168,28.61,44.12,44.12,0,0,1,171,44.72a44.18,44.18,0,0,1-3.54,17.58,45.31,45.31,0,0,1-24,24.07A43.75,43.75,0,0,1,125.9,89.91Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M196.69,89.32H182.88V1.18h13.81Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M245.53,1.3h57.11V14.87H259.1V34.34H245.53Zm13.57,47V75.63h43.54V89.2H245.53V48.26ZM297,34.69V48.26H273.26V34.69Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M374.85,89.08,329.66,32.21V89.08h-13.8V.94h6.72l48.14,60.77V.94h13.81V89.08Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M396.68,1.3h57.11V14.87H410.25V34.34H396.68Zm13.57,47V75.63h43.54V89.2H396.68V48.26Zm37.87-13.57V48.26H424.41V34.69Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M516.83,89.08l-23-33.27H479.39V89.44H465.58V.94l40.71.12a26.11,26.11,0,0,1,10.62,2.18,28.52,28.52,0,0,1,8.67,5.9,27,27,0,0,1,5.84,8.79,27.52,27.52,0,0,1,2.13,10.74,26.59,26.59,0,0,1-6.73,17.88,28.1,28.1,0,0,1-7.43,6,26.49,26.49,0,0,1-9.21,3.06l23.25,33.51Zm-10.5-46.84a12.85,12.85,0,0,0,5.24-1.06,13.39,13.39,0,0,0,4.23-3,14.28,14.28,0,0,0,2.88-4.31,12.86,12.86,0,0,0,1.06-5.25,13.75,13.75,0,0,0-1.06-5.37,13.47,13.47,0,0,0-2.94-4.42,14.78,14.78,0,0,0-4.29-3,12.26,12.26,0,0,0-5.24-1.12H479.39V42.12Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M614.61,79.76l-3.07,2.12a41.93,41.93,0,0,1-11.62,5.49,45,45,0,0,1-12.81,1.83A42.48,42.48,0,0,1,570,85.72a45.63,45.63,0,0,1-14-9.44,44.19,44.19,0,0,1-9.49-14A42.82,42.82,0,0,1,543,45.07,42.56,42.56,0,0,1,546.47,28,44.42,44.42,0,0,1,556,14a45.63,45.63,0,0,1,14-9.44,42.48,42.48,0,0,1,17.1-3.48,45,45,0,0,1,12.81,1.83,41.93,41.93,0,0,1,11.62,5.49L604,19.7a30,30,0,0,0-16.88-5.07,29.49,29.49,0,0,0-11.91,2.42A30.89,30.89,0,0,0,559,33.27,30.27,30.27,0,0,0,559,57,30.89,30.89,0,0,0,575.2,73.21a29.32,29.32,0,0,0,11.91,2.42A30.31,30.31,0,0,0,601,72.33V48H587.11V34.45h27.5Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M689.88.94,662,47V89.08H648.23V47L620.74.94h16l18.4,30.68L673.72.94Z"
})));

var SvgLogoTagline = function SvgLogoTagline(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 689.88 133.05",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoTagline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_tagline.31bdd58d.svg";
export { ForwardRef as ReactComponent };